
/**
 * Style management
 * */

document.addEventListener('DOMContentLoaded', function () {

    if (document.body.classList.contains('pages') && !document.body.classList.contains('ispreview')) {

        // If multiple blocks are asking for authentification, only show one of those block.
        // Not applied in preview mode (visual editor)

        const blocks = document.querySelectorAll('.ve-block');
        const blocks_with_authentification = document.querySelectorAll('.ve-block .pincode');
        let counter = 0;

        if (blocks_with_authentification.length > 1) {
            blocks.forEach(block => {
                if (block.querySelector('.pincode')) {
                    if (counter !== 0) {
                        block.classList.add('hide');
                    }
                    counter++;
                }
            });
        }
    }

});

/**
 * Visual Editor for Page builder.
 * https://www.npmjs.com/package/@boxraiser/visual-editor
 */

import {
    VisualEditor,
    HTMLText,
    Repeater,
    Text,
    Number,
    Row,
    Select,
    ImageUrl,
    Alignment,
    Checkbox,
    Switch,
    DateInput,
    TimeInput,
    Timezone
} from './common/visual-editor-0.9.0.standalone.js';

const labels = window.pg_labels || {};
const pg_event = window.pg_event || {};
window.store = window.store || {};

/**
 * Use full attributes example
 *
 * Text('unique_id', {
        isuniqueid: true,
        readonly: true
    })
 */

document.addEventListener('DOMContentLoaded', function () {

    /** Define Visual edito components. */
    const editor = new VisualEditor({
        color: 'inherit'
    });

    /** Block Who's who */
    const whoswhoComponentFields = [
        Row([
            Switch('show_search', {
                label: labels.show_search || '-',
                default: true,
            }),
            Switch('show_modal', {
                label: labels.show_modal || '-',
                default: true,
            }),
        ], {
            label: labels.extra,
            columns: '1fr 1fr',
        }),
        Row([
            Switch('show_picture', {
                label: labels.show_picture || '-',
                default: true,
            }),
            Switch('show_jobtitle', {
                label: labels.show_jobtitle || '-',
                default: true,
            }),
            Switch('show_company', {
                label: labels.show_company || '-',
                default: true,
            }),
            Switch('show_biography', {
                label: labels.show_biography || '-',
                default: true,
            }),
            Switch('show_email', {
                label: labels.show_email || '--',
                default: false,
            }),
            Switch('show_country', {
                label: labels.show_country || '-',
                default: false,
            }),
            Switch('show_website', {
                label: labels.show_website || '-',
                default: false,
            }),
            Switch('show_socials', {
                label: labels.show_socials || '-',
                default: false,
            }),
        ], {
            label: labels.infos,
            columns: '1fr 1fr',
        }),
    ];

    if (window.pg_groups && Object.values(window.pg_groups).length >= 1) {
        const row_groups = [];

        window.pg_groups.forEach((group) => {
            const groupKey = group.uuid;
            row_groups.push(
                Switch(`group_${groupKey}`, {
                    label: group.title || group.name || String(groupKey),
                    default: true,
                })
            );
        });

        row_groups.push(
            Switch('group_none', {
                label: labels.ungrouped,
                default: false,
            })
        );

        whoswhoComponentFields.push(
            Row(row_groups, {
                label: labels.groups,
                columns: '1fr 1fr',
            })
        );
    }

    whoswhoComponentFields.push(
        Text('unique_id', {
            label: labels.uniquecssclass,
            isuniqueid: true,
            onInput: uniqueIDInput,
        })
    );

    editor.registerComponent('whoswho', {
        title: labels.whoswho,
        category: labels.management,
        fields: whoswhoComponentFields
    });

    /** Block Live */
    const live_component_fields = [
        Text('unique_id', {
            label: labels.uniquecssclass,
            isuniqueid: true,
            onInput: uniqueIDInput,
        })
    ];

    if (window.pg_lives && (Object.values(window.pg_lives).length >= 1)) {
        const selector_unique_id = `live-selector-${(Date.now().toString(36) + Math.random().toString(36).slice(2))}`;
        live_component_fields.push(Select('live', {
            label: labels.live,
            default: window.pg_lives[0].uuid,
            options: [
                ...window.pg_lives.map(l => ({ label: l.title, value: l.uuid }))
            ],
            selector: selector_unique_id,
            onLoad: () => {
                const selectEl = this.querySelector(`[data-selector="${selector_unique_id}"]`);
                if (selectEl) {
                    Array.from(selectEl.options).forEach((option, i) => {
                        if (window.pg_lives[i]?.title) {
                            option.innerHTML = window.pg_lives[i].title;
                        } else {
                            console.log('Cannot find option title');
                        }
                    });
                } else {
                    console.log('Cannot find lives selector #1');
                }
            }
        }));
    }

    editor.registerComponent('live', {
        title: labels.live,
        category: labels.extra,
        fields: live_component_fields
    });

    /** Block Rooming */
    editor.registerComponent('rooming', {
        title: labels.rooming,
        category: labels.management,
        fields: [
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Program */
    let program_component_fields = [];

    if (window.pg_calendars && (window.pg_calendars.length > 1)) {
        program_component_fields.push(Select('calendar', {
            default: 'all',
            label: labels.calendar_to_display,
            options: [
                { label: 'All', value: 'all' },
                ...window.pg_calendars.map(p => ({ label: p.title, value: p.uuid }))
            ]
        }));
    }

    program_component_fields = [
        ...program_component_fields,
        Select('user_interface', {
            default: 'advanced',
            label: labels.user_interface,
            className: 'program-block-select-user_interface',
            options: [
                { label: labels.advanced, value: 'advanced' },
                { label: labels.standard, value: 'standard' }
            ],
            onLoad: () => {
                const selectEl = document.querySelector('select.program-block-select-user_interface');

                if (selectEl) {
                    toggleProgramOptionsAvaibility(selectEl);
                    selectEl.addEventListener('change', () => {
                        toggleProgramOptionsAvaibility(selectEl);
                    });
                }
            },
        }),
        Switch('show_program_filters', {
            label: labels.show_program_filters,
            default: true,
            className: 'program-block-checkbox-show_program_filters',
        }),
        Switch('show_bookmarks', {
            label: labels.show_bookmarks,
            default: true,
            className: 'program-block-checkbox-show_bookmarks',
        }),
        Switch('show_speakers_in_sessions', {
            label: labels.show_speakers_in_sessions,
            default: true,
            className: 'program-block-checkbox-show_speakers_in_sessions',
        }),
        Switch('show_tags_in_sessions', {
            label: labels.show_tags_in_sessions,
            default: true,
            className: 'program-block-checkbox-show_tags_in_sessions',
        }),
        Switch('show_session_details', {
            label: labels.show_session_details,
            default: true,
            className: 'program-block-checkbox-show_session_details',
        }),
        Select('details_display', {
            default: 'inline',
            label: labels.details_display,
            className: 'program-block-select-details_display',
            options: [
                { label: labels.inline, value: 'inline' },
                { label: labels.modale, value: 'modale' }
            ]
        }),
    ];

    program_component_fields.push(
        Text('unique_id', {
            label: labels.uniquecssclass,
            isuniqueid: true,
            onInput: uniqueIDInput
        })
    );

    editor.registerComponent('program', {
        title: labels.program,
        category: labels.management,
        fields: program_component_fields,
    });

    function toggleProgramOptionsAvaibility(selectEl) {

        if (!selectEl) return;

        const isAdvanced = selectEl.value === 'advanced';
        const editorRoot = selectEl.closest('visual-editor') || document;
        const advancedOptionsSelectors = [
            '.program-block-checkbox-show_program_filters',
            '.program-block-select-details_display',
        ];

        advancedOptionsSelectors.forEach(selector => {

            let el = editorRoot.querySelector(selector);
            let elLabel = editorRoot.querySelector(`${selector}-label`);

            if (el) {
                el.parentElement.style.display = isAdvanced ? 'block' : 'none';
            }
            if (elLabel) {
                elLabel.style.display = isAdvanced ? 'block' : 'none';
            }

        });

    }

    /** Block Speakers */
    editor.registerComponent('speakers', {
        title: labels.speakers,
        category: labels.management,
        fields: [
            Select('user_interface', {
                default: 'list',
                label: labels.user_interface,
                className: 'speakers-block-select-user_interface',
                options: [
                    { label: labels.list, value: 'list' },
                    { label: labels.carousel, value: 'carousel' }
                ],
                onLoad: () => {
                    const selectEl = document.querySelector('select.speakers-block-select-user_interface');

                    if (selectEl) {
                        toggleSpeakersOptionsAvaibility(selectEl);
                        selectEl.addEventListener('change', () => {
                            toggleSpeakersOptionsAvaibility(selectEl);
                        });
                    }
                },
            }),
            Number('rows', {
                label: labels.carousel_max_rows,
                default: 2,
                className: 'speakers-block-number-carousel_max_rows'
            }),
            Number('columns', {
                label: labels.carousel_max_columns,
                default: 4,
                className: 'speakers-block-number-carousel_max_columns'
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    function toggleSpeakersOptionsAvaibility(selectEl) {

        if (!selectEl) return;

        const isCarousel = selectEl.value === 'carousel';
        const editorRoot = selectEl.closest('visual-editor') || document;
        const advancedOptionsSelectors = [
            '.speakers-block-number-carousel_max_rows',
            '.speakers-block-number-carousel_max_columns'
        ];

        advancedOptionsSelectors.forEach(selector => {

            let el = editorRoot.querySelector(selector);

            if (el) {
                el.parentElement.style.display = isCarousel ? 'block' : 'none';
            }

        });

    }

    /** Block Authentication */
    editor.registerComponent('authentication', {
        title: labels.authentication,
        category: labels.management,
        fields: [
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });


    /** Block Subscription */
    editor.registerComponent('subscription', {
        title: labels.subscription,
        category: labels.management,
        fields: [
            Text('title', {
                label: labels.title,
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Text */
    editor.registerComponent('text', {
        title: labels.text,
        category: labels.content,
        fields: [
            HTMLText('content', {
                label: labels.content,
                multiline: true
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Title */
    editor.registerComponent('title', {
        title: labels.title,
        category: labels.content,
        fields: [
            HTMLText('content', {
                label: labels.content,
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });


    /** Block Text + Text */
    editor.registerComponent('text-text', {
        title: labels.text_text,
        category: labels.content,
        fields: [
            HTMLText('content_1', {
                label: labels.text_left,
                multiline: true
            }),
            HTMLText('content_2', {
                label: labels.text_right,
                multiline: true
            }),
            Select('columns_ratio', {
                default: '6/6',
                label: labels.columnsratio,
                options: [
                    { label: '1/11', value: '1/11' },
                    { label: '2/10', value: '2/10' },
                    { label: '3/9', value: '3/9' },
                    { label: '4/8', value: '4/8' },
                    { label: '5/7', value: '5/7' },
                    { label: '6/6', value: '6/6' },
                    { label: '7/5', value: '7/5' },
                    { label: '8/4', value: '8/4' },
                    { label: '9/3', value: '9/3' },
                    { label: '10/2', value: '10/2' },
                    { label: '11/1', value: '11/1' }
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            }),
        ]
    });

    /** Block Text + Image */
    editor.registerComponent('text-image', {
        title: labels.text_image,
        category: labels.content,
        fields: [
            HTMLText('content', {
                label: labels.content,
                multiline: true
            }),
            ImageUrl('image', {
                label: labels.image,
                onBrowse: () => blocEditorBrowse(),
                tooltip: false
            }),
            Text('url', {
                label: labels.link,
            }),
            Switch('new_window', {
                label: labels.open_in_new_window,
                default: false,
            }),
            Alignment('align', {
                label: labels.align,
                default: 'left',
                vertical: false
            }),
            Select('columns_ratio', {
                default: '6/6',
                label: labels.columnsratio,
                options: [
                    { label: '1/11', value: '1/11' },
                    { label: '2/10', value: '2/10' },
                    { label: '3/9', value: '3/9' },
                    { label: '4/8', value: '4/8' },
                    { label: '5/7', value: '5/7' },
                    { label: '6/6', value: '6/6' },
                    { label: '7/5', value: '7/5' },
                    { label: '8/4', value: '8/4' },
                    { label: '9/3', value: '9/3' },
                    { label: '10/2', value: '10/2' },
                    { label: '11/1', value: '11/1' }
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            }),
        ]
    });

    /** Block Image + Image */
    editor.registerComponent('image-image', {
        title: labels.image_image,
        category: labels.media,
        fields: [
            Number('height', {
                label: labels.custom_height_px,
            }),
            ImageUrl('image_1', {
                label: `${labels.image} #1`,
                onBrowse: () => blocEditorBrowse(),
                tooltip: false
            }),
            Text('url_1', {
                label: `${labels.link} #1`,
            }),
            Switch('new_window_1', {
                label: `${labels.open_in_new_window} #1`,
                default: false,
            }),
            ImageUrl('image_2', {
                label: `${labels.image} #2`,
                onBrowse: () => blocEditorBrowse(),
                tooltip: false
            }),
            Text('url_2', {
                label: `${labels.link} #2`,
            }),
            Switch('new_window_2', {
                label: `${labels.open_in_new_window} #2`,
                default: false,
            }),
            Select('columns_ratio', {
                default: '6/6',
                label: labels.columnsratio,
                options: [
                    { label: '1/11', value: '1/11' },
                    { label: '2/10', value: '2/10' },
                    { label: '3/9', value: '3/9' },
                    { label: '4/8', value: '4/8' },
                    { label: '5/7', value: '5/7' },
                    { label: '6/6', value: '6/6' },
                    { label: '7/5', value: '7/5' },
                    { label: '8/4', value: '8/4' },
                    { label: '9/3', value: '9/3' },
                    { label: '10/2', value: '10/2' },
                    { label: '11/1', value: '11/1' }
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Image */
    editor.registerComponent('image', {
        title: labels.image,
        category: labels.media,
        fields: [
            Number('height', {
                label: labels.custom_height_px,
            }),
            ImageUrl('image', {
                label: `${labels.image} (png/jpg/jpeg/gif < 5MB)`,
                onBrowse: () => blocEditorBrowse()
            }),
            Text('url', {
                label: labels.link,
            }),
            Switch('new_window', {
                label: labels.open_in_new_window,
                default: false,
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Carousel */
    editor.registerComponent('carousel', {
        title: labels.carousel,
        category: labels.media,
        fields: [
            Number('height', {
                label: labels.custom_height_px,
            }),
            Number('delay', {
                label: labels.speed_ms,
            }),
            Switch('show_pagination', {
                label: labels.show_pagination,
                default: false,
            }),
            Switch('show_navigation_buttons', {
                label: labels.show_navigation_buttons,
                default: false,
            }),
            Repeater('images', {
                title: labels.images,
                addLabel: labels.add_image,
                min: 1,
                fields: [
                    ImageUrl('image', {
                        label: labels.image,
                        onBrowse: () => blocEditorBrowse()
                    })
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Embedded */
    editor.registerComponent('embed', {
        title: 'Embed',
        category: labels.media,
        fields: [
            Text('iframe', {
                label: labels.iframe,
                multiline: true
            }),
            Select('ratio', {
                label: labels.format,
                default: '16x9',
                options: [
                    {
                        value: '16x9',
                        label: '16/9'
                    }, {
                        value: '4x3',
                        label: '4/3'
                    }, {
                        value: '1x1',
                        label: labels.square,
                    }, {
                        value: 'none',
                        label: labels.free,
                    }
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Hero */
    editor.registerComponent('hero', {
        title: labels.hero,
        category: labels.banner,
        fields: [
            Text('title', {
                label: labels.title,
                multiline: false,
                allowHeadings: false,
            }),
            HTMLText('content', {
                label: labels.content,
                multiline: true,
                allowHeadings: false,
            }),
            Repeater('buttons', {
                title: labels.buttons,
                addLabel: labels.add_button,
                collapsed: 'label',
                fields: [
                    Row([
                        Text('label', { label: labels.label, default: labels.click_here }),
                        Text('url', { label: labels.link }),
                        Select('type', {
                            default: 'primary',
                            label: labels.type,
                            options: [
                                { label: 'Primaire', value: 'primary' },
                                { label: 'Secondaire', value: 'secondary' }
                            ]
                        })
                    ])
                ]
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block Countdown */
    editor.registerComponent('countdown', {
        title: labels.countdown,
        category: labels.extra,
        fields: [
            Text('title', {
                label: labels.title,
            }),
            Text('subtitle', {
                label: 'Sous-Titre',
            }),
            Switch('show_days', {
                label: labels.show_days,
                default: false,
            }),
            Switch('show_seconds', {
                label: labels.show_seconds,
                default: false,
            }),
            Text('redirect', { label: labels.redirection_url }),
            ImageUrl('background_image', {
                label: labels.background_image,
                onBrowse: () => blocEditorBrowse(),
                tooltip: false
            }),
            Row([
                DateInput('date', {
                    label: labels.date || 'Date',
                }),
                TimeInput('time', {
                    label: labels.time || 'Time',
                }),
                Timezone('timezone', {
                    label: labels.timezone || 'Timezone',
                    default: pg_event.timezone || null,
                }),
            ]),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    /** Block spacer */
    editor.registerComponent('spacer', {
        title: labels.spacer,
        category: labels.extra,
        fields: [
            Number('height', {
                label: labels.height_px,
            }),
            Text('unique_id', {
                label: labels.uniquecssclass,
                isuniqueid: true,
                onInput: uniqueIDInput,
            })
        ]
    });

    editor.defineElement();

    /** Set visual editor browsing components mecanism. */
    function blocEditorBrowse() {
        return new Promise(function (resolve, reject) {
            if (Livewire) {
                Livewire.dispatch('page.image.preupload');

                Livewire.on('fileUploaded', (media) => {
                    resolve(media[0]);
                });
            } else {
                reject('No Livewire instance found.');
            }

            /*
            var input = document.getElementById('visual-editor-file-upload_image');
            if (input) {
                input.click();
            }

            if (Livewire) {
                Livewire.on('fileUploaded', (media_url) => {
                    resolve(media_url);
                });
            } else {
                reject('No Livewire instance found.');
            }
                */
        });
    }

    /** Unique ID input management */
    function uniqueIDInput(event) {
        const regex = /^[a-zA-Z0-9-_]+$/;
        let currentValue = event.target.value;
        let lastChar = currentValue.charAt(currentValue.length - 1);
        if (!regex.test(lastChar)) {
            event.target.value = currentValue.slice(0, -1);
        }
    }

    /** Avatar dynamic update */
    window.addEventListener('whoswho-avatar-updated', (event) => {
        const avatarUrl = event.detail.avatarUrl ?? null;
        const avatarImages = document.querySelectorAll('[data-page-header-avatar]');

        avatarImages.forEach((avatarImage) => {
            if (avatarUrl) {
                avatarImage.src = avatarUrl;
                avatarImage.classList.remove('d-none');
            } else {
                avatarImage.removeAttribute('src');
                avatarImage.classList.add('d-none');
            }
        });
    });
});
